import { ROUTES } from '@/constants/routes';
import { useSavRequestsUnreadCount } from '@/hooks/useSavRequestsUnreadCount';
import { WrenchScrewdriverIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

/**
 * Icône « Demandes SAV du site » de l'en-tête (à côté de celle des messages), avec pastille du nombre de nouvelles demandes.
 * N'est rendue que pour les rôles disposant de la permission 'sav_requests'.
 */
export function SavInboxButton() {
  const navigate = useNavigate();
  const { allowed, count } = useSavRequestsUnreadCount();

  if (!allowed) return null;

  const unread = count ?? 0;

  return (
    <button
      onClick={() => navigate(ROUTES.SAV_REQUESTS)}
      className="layout-header-btn-hover relative p-2 rounded-token-md focus:outline-none focus:ring-2 focus:ring-token-focus focus:ring-offset-token-focus transition-colors duration-200"
      aria-label={
        unread > 0
          ? `Demandes SAV du site, ${unread} nouvelle${unread > 1 ? 's' : ''}`
          : 'Demandes SAV du site'
      }
      title="Demandes SAV du site"
    >
      <WrenchScrewdriverIcon className="h-6 w-6" />
      {unread > 0 && (
        <span
          data-testid="sav-badge"
          className="absolute -top-0.5 -right-0.5 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold leading-none"
        >
          {unread > 99 ? '99+' : unread}
        </span>
      )}
    </button>
  );
}
